import React from 'react';
import {Form, Spinner} from 'react-bootstrap';
import {FaRobot} from 'react-icons/fa';
import {useTranslation} from 'react-i18next';

const RepFeatureControl = ({enabled, loading, saving, onToggle}) => {
  const {t} = useTranslation();
  return <section className={`admin-rep-feature ${enabled ? 'is-enabled' : 'is-disabled'}`} aria-busy={loading || saving}>
    <div className="admin-rep-feature__icon"><FaRobot aria-hidden="true"/></div>
    <div className="admin-rep-feature__copy">
      <span>{t('REP_FEATURE_CONTROL')}</span>
      <strong>{loading ? t('LOADING') : t(enabled ? 'REP_FEATURE_ENABLED' : 'REP_FEATURE_DISABLED')}</strong>
      <small>{t('REP_FEATURE_CONTROL_HELP')}</small>
    </div>
    <div className="admin-rep-feature__switch">
      {saving ? <Spinner animation="border" size="sm"/> : null}
      <Form.Check
        id="hey-rep-enabled"
        type="switch"
        label={t(enabled ? 'REP_DISABLE' : 'REP_ENABLE')}
        aria-label={t(enabled ? 'REP_DISABLE' : 'REP_ENABLE')}
        checked={enabled}
        disabled={loading || saving}
        onChange={event => onToggle(event.target.checked)}
      />
    </div>
  </section>;
};

export default RepFeatureControl;
